/* eslint-disable no-restricted-syntax */
import layerService from '@/services/layer-service'

import LayerGroup from '@/fish/components/layers/fish-layer-group'

/** Class responsible for handling collections */
export default class Collection {
  /**
   * @constructor
   */
  constructor(collectionData) {
    this.id = collectionData.unique_code
    this.name = collectionData.name
    this.icon = collectionData.icon
    this.type = collectionData.type
    this.description = collectionData.description
    this.rawLayers = collectionData.layers
    this.layersRequested = !!this.rawLayers.length
    this.layers = []

    // Add to layer service
    layerService.addCollection(this)

    // Parse the collection's layer groups
    this.parseGroups()
  }

  /**
   * Parse the collection's layer groups
   */
  parseGroups() {
    for (const group of this.rawLayers) {
      const layerGroup = new LayerGroup(group)
      this.layers.push(layerGroup)
    }
  }
}
